// extracted by mini-css-extract-plugin
module.exports = {"remove":"styles-module__remove___4LaVq","add":"styles-module__add___2LpfG"};